<template>
  <nav 
    :class="navClasses"
    class="bg-white h-auto w-screen flex items-center justify-center fixed left-0 right-0 z-50 transition-transform duration-500"
  >
    <NavBarContentDesktop
      :menu-items="menuItems"
      :logo-props="logoProps"
      :contact-action="contactAction"
      :contact-text="contactText"
    />
    <NavBarContentMobile
      :menu-items="menuItems"
      :logo-props="logoProps"
    />
  </nav>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import NavBarContentDesktop from './desktop/components/NavBarContentDesktop.vue'
import NavBarContentMobile from './mobile/components/NavBarContentMobile.vue'
import type { NavBarProps } from './desktop/types/navigation'

interface Props {
  menuItems?: NavBarProps['menuItems']
  logoProps?: NavBarProps['logoProps']
  contactAction?: NavBarProps['contactAction']
  contactText?: NavBarProps['contactText']
}

defineProps<Props>()

const prevScrollPos = ref(0)
const visible = ref(true)

const navClasses = computed(() => ({
  'translate-y-0': visible.value,
  '-translate-y-full': !visible.value
}))

const handleScroll = () => {
  const currentScrollPos = window.scrollY
  visible.value = prevScrollPos.value > currentScrollPos || currentScrollPos < 30
  prevScrollPos.value = currentScrollPos
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

